import FolderOpenOutlinedIcon from "@mui/icons-material/FolderOpenOutlined";
import { Box, Typography } from "@mui/material";

export function EmptyState() {
  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      py={6}
      gap={1.5}
    >
      <FolderOpenOutlinedIcon sx={{ fontSize: 72, color: "#CBD5E1" }} />
      <Typography
        fontSize={14}
        fontWeight={500}
        color="#6B7280"
        textAlign="center"
      >
        Ainda não há documentos por aqui!
      </Typography>
    </Box>
  );
}
